/**
 * Close OS-level push notifications.
 *
 * Uses a fetch to /__clear-notifications which the SW intercepts. The SW:
 * 1. Queries each tracked tag individually (per-tag queries work on Android
 *    Chrome even when grouped/bundled notifications break tagless queries)
 * 2. Falls back to a tagless getNotifications() to catch anything remaining
 * 3. Only removes tags from the cache that were actually found and closed,
 *    so subsequent calls can retry unclosed tags
 */
export const clearPushNotifications = (): void => {
  if (!('serviceWorker' in navigator)) return;
  fetch('/__clear-notifications').catch(() => {});
};
